import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  countries: any[]=[];
  states: any[]=[];
  ranges: any[]=[];
  products: number = 0;
  rol: number = 0;

  constructor(
    private adminservice: AdminService,
    private storeservice: StoreService,
    private dialogRef: MatDialogRef<FiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  
  ngOnInit() {
    this.rol = +this.storeservice.getProfile.rol_id;
    this.products = this.data?.products ?? 0;
    this.getCountries();
    this.getStates();
    if (this.rol == 1) {
      this.getRanges();
    }
  }

  getRanges(){
    this.adminservice.getRanges().subscribe(
      (response)=>{
        if (response.rtn) {
          this.ranges = response.result;
          this.ranges.forEach((element)=>{
            element.selected = this.data?.ranges?.includes(element.descripcion) ?? false;
          })
        }
      }
    );
  }

  getCountries(){
    this.adminservice.getCountries().subscribe(
      (response)=>{
        if (response.rtn) {
          this.countries = response.result;
          this.countries.forEach((element)=>{
            element.checked = this.data?.countries?.includes(element.descripcion) ?? false;
          })
        }
      }
    );
  }

  getStates(){
    this.adminservice.getStates().subscribe(
      (response)=>{
        let statesTemp = response.filter((element)=> this.rol == 1 ? element.isAdmin : !element.isAdmin );
        this.states = statesTemp;
        this.states.forEach((element)=>{
          element.selected = this.data?.states?.includes(element.label) ?? false;
        });
      }
    );
  }

  sendFilters(){
    let countriesSelected = this.countries.filter((element)=>element.checked).map((element)=>(element.descripcion));
    let statesSelected = this.states.filter((element)=>element.selected).map((element)=>(element.label));
    let rangesSelected = this.ranges.filter((element)=>element.selected).map((element)=>(element.descripcion));
    const filters = {
      countries: countriesSelected,
      states: statesSelected,
      ranges: rangesSelected,
      products: this.products
    }
    this.dialogRef.close(filters);
  }

}
